import React, { useState } from 'react';
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Modal,
    ModalFooter,
    CardImg,
    ModalHeader,
    ModalBody,
} from 'reactstrap';

import Select from 'react-select';
import Dropzone from 'react-dropzone';
import { Cropper } from 'react-image-cropper';
import { LoadingSpinner } from '../../../components';
import AlertExpire from '../../../components/AlertExpire';
import { GetCompanyInfoById, saveCompanyInfo, GetTimeZones } from '../../../api/CompanyInfo';
import Dashboard from '../../Dashboard/Dashboard';
import 'react-intl-tel-input/dist/main.css';
import { connect } from 'react-redux';
import CompanyEntryList from './CompanyEntryList';

let dropzoneRef;
const imageExt = ".jpg, .png, .jpeg, .gif, .bmp, .tiff";


class CompanyInfoEntryDetail extends React.Component {

    static routeName = '/info/company-entry';

    state = {
        errors: [],
        successMessage: '',
        messageVisible: false,

        companyId: "",
        companyName: "",
        phoneNb: "",
        address: "",
        logo: "",
        logoToDelete: "",
        tmpDropImage: null,
        imageCropperModal: false,
        imageErrorModal: false,
        imageErrorModalMessage: "",
        saleStatus: "",
        notiMessage: "",
        contactPerson: "",
        contactPhoneNb: "",
        isLoading: false,
        isExpired: false,
        updatedBy: this.props.auth.displayName,
        isValidPhoneNo: true,
        isValidContactPhoneNo: true,
        startTime: null,
        endTime: null,
        selectedTimeZoneId: { label: '(UTC+06:30) Yangon (Rangoon)', value: 'Myanmar Standard Time' },
        timezonesList: [],
        formState: "new",

    }
    updateState(prop, value) {
        this.setState({ [prop]: value });
    }


    async loadData() {
        if(Object.keys(this.props.match.params).length === 0 ){
                this.state.companyId = this.props.auth.companyId;
        }else if(Object.keys(this.props.match.params).length === 1){
            this.state.companyId = this.props.match.params.id;
        }
        
        const resdataById = await GetCompanyInfoById(this.state.companyId);
        console.log(resdataById);
        const timezones = await GetTimeZones();
        const timezonelist = [];
        const selectedTimeZoneId = { label: '(UTC+06:30) Yangon (Rangoon)', value: 'Myanmar Standard Time' };

        timezones.data.forEach(i => {
            timezonelist.push({ label: i.displayName, value: i.id })
            timezonelist.push({ label: i.displayName, value: i.id })
        });


        if (resdataById === 401) {
            this.setState({ isExpired: true })
        } else {

            let res = resdataById.data;


            timezonelist.forEach(row => {
               
                if (res.timeZoneId === row.value) {
                    selectedTimeZoneId.label = row.label;
                    selectedTimeZoneId.value = row.value;
                }
            })



            this.setState({
                companyId: res.companyId,
                companyName: res.companyName,
                phoneNb: res.phoneNb,
                address: res.address === null ? "" : res.address,
                logo: res.logo === null ? "" : res.logo,
                saleStatus: res.saleStatus === null ? "" : res.saleStatus,
                notiMessage: res.notiMessage === null ? "" : res.notiMessage,
                contactPerson: res.contactPerson === null ? "" : res.contactPerson,
                contactPhoneNb: res.contactPhoneNb === null ? "" : res.contactPhoneNb,
                selectedTimeZoneId: selectedTimeZoneId,
                startTime: res.topupStartTime,
                endTime: res.topupEndTime,
                isLoading: false,
                timezonesList: timezonelist,

            })
        }

    }

    async componentDidMount() {
        await this.loadData();
    }

    onPhoneNoChange(status, value) {
        this.setState({
            phoneNb: value,
            isValidPhoneNo: status,
        });
    }

    onContactPhoneNoChange(status, value) {
        this.setState({
            contactPhoneNb: value,
            isValidContactPhoneNo: status,
        });
    }

    onDropImage(file) { //drop file
        let error = this.onDropValidation(file);
        if (!error) {
            this.setState({
                tmpDropImage: file,
                imageCropperModal: true,
            })
        }
    }
    onDropValidation(file) { //validate drop file extensions & limitation
        if (!file) {
            this.setState({
                imageErrorModal: true,
                imageErrorModalMessage: `File must not upload except ${imageExt} extensions.`
            });
            return true;
        }
        if (this.state.logo != "") {
            this.setState({
                imageErrorModal: true,
                imageErrorModalMessage: "Photo must not upload more than 1."
            });
            return true;
        }
        return false;
    }
    setCroppedImage() { //create Image (Info, base64) 
        let img = this.state.logo;
        let logoToDelete = this.state.logoToDelete;
        if (!logoToDelete && img && img.indexOf("static/") !== -1) {
            // Replacing an already stored logo - flag the old file for deletion.
            logoToDelete = img;
        }
        img = this.cropper.crop();
        this.setState({
            logo: img,
            logoToDelete,
            tmpDropImage: null,
            imageCropperModal: false
        })
    }

    deleteImage() { //delete Image (Info, base64)
        let image = this.state.logo;
        this.setState({
            logo: "",
            logoToDelete: image
        })
    }

    toggle(prop) { //close modal
        this.setState({
            [prop]: false,
            imageErrorModalMessage: "",
            tmpDropImage: null,
        });
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col xs="12" lg="8">
                        <Card>
                            {this.state.isExpired && <AlertExpire />}
                            {this.state.isLoading && <LoadingSpinner />}
                            <CardHeader>
                                <strong>Update Company Info</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" onSubmit={(values) => this.submitHandle(values)}>
                                    <Row xs="12" lg="12">
                                        <Col xs="12" lg="12">
                                            <Col>
                                                <Row lg="12" xs="12">
                                                    <Col lg="4" xs="12">
                                                        <FormGroup>
                                                            <Label htmlFor="photo">Logo
                                                                {(this.state.logo != "") ?
                                                                    <span className="fa fa-trash-o fa-lg" style={{ marginLeft: 20, color: "red", cursor: "pointer" }}
                                                                        onClick={() => this.deleteImage(this.state.index)}></span>
                                                                    :
                                                                    ""
                                                                }
                                                            </Label>
                                                            <Dropzone
                                                                style={{ border: '2px dashed LightGray', padding: 10 }}
                                                                ref={(node) => { dropzoneRef = node }}
                                                                accept={imageExt}
                                                                onDrop={(file) => this.onDropImage(file[0])}
                                                                disableClick={true}
                                                                multiple={true}
                                                                maxsize={2000000} // 2MB
                                                            >
                                                                {(this.state.logo.length != "") ?
                                                                    <Row lg="12" xs="12">
                                                                        <Col lg="12" xs="12" width="200" height="200">
                                                                            <div>
                                                                                <CardImg draggable="false" src={this.state.logo}></CardImg>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    :
                                                                    <>
                                                                        <Button outline color="success" onClick={() => dropzoneRef.open()}>Choose File</Button><br />Or Drop File<br /><br />
                                                                        <ul><li>&nbsp;&nbsp;No file choosen</li></ul>
                                                                    </>
                                                                }
                                                            </Dropzone>
                                                        </FormGroup>
                                                    </Col>

                                                    <Modal isOpen={this.state.imageErrorModal} toggle={() => this.toggle("imageErrorModal")}>
                                                        <ModalHeader toggle={() => this.toggle("imageErrorModal")}>Photo Message</ModalHeader>
                                                        <ModalBody>
                                                            {this.state.imageErrorModalMessage}
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button color="secondary" onClick={() => this.toggle("imageErrorModal")}>Close</Button>
                                                        </ModalFooter>
                                                    </Modal>

                                                    <Modal isOpen={this.state.imageCropperModal} toggle={() => this.toggle("    ")}>
                                                        <ModalHeader toggle={() => this.toggle("imageCropperModal")}>Uploaded Photo</ModalHeader>
                                                        <ModalBody>
                                                            <Cropper
                                                                src={this.state.tmpDropImage ? this.state.tmpDropImage.preview : ''}
                                                                ref={cropRef => { this.cropper = cropRef }}
                                                                ratio={1 / 1}
                                                                width={300}
                                                            />
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button color="success" disabled={!this.state.imageCropperModal} onClick={() => this.setCroppedImage()}>Upload</Button>
                                                            <Button color="secondary" onClick={() => this.toggle("imageCropperModal")}>Cancel</Button>
                                                        </ModalFooter>
                                                    </Modal>

                                                    <Col lg="8" xs="12">
                                                        {/* Phone Number */}
                                                        <Col lg="12" xs="12">
                                                            <FormGroup>
                                                                <Label htmlFor="phoneNb" required>Phone Number<span className="text-danger">*</span></Label><br />
                                                                <Input
                                                                    className='product-mastersim-filter-dropdown-width'
                                                                    id="phoneNb" name="phoneNb" type="text"
                                                                    placeholder="Enter Phone Number"
                                                                    maxLength={11}
                                                                    value={this.state.phoneNb}
                                                                    onChange={(e) => this.updateState("phoneNb", e.target.value)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        {/* Company Name */}
                                                        <Col lg="12" xs="12">
                                                            <FormGroup>
                                                                <Label htmlFor="name" required>Company Name <span className="text-danger">*</span></Label>
                                                                <Input
                                                                    id="companyName" name="companyName" type="text"
                                                                    placeholder="Company Name ..."
                                                                    maxLength={100}
                                                                    value={this.state.companyName}
                                                                    onChange={(e) => this.updateState("companyName", e.target.value)}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            {/* Time Zones */}
                                            <FormGroup>
                                                <Label htmlFor="ProductType" required>Time Zone<span style={{ color: 'red' }}> * </span></Label><br />
                                                <Select
                                                    options={this.state.timezonesList}
                                                    value={this.state.selectedTimeZoneId}
                                                    defaultValue={this.state.selectedTimeZoneId}
                                                    onChange={(value) => this.updateState("selectedTimeZoneId", value)} />
                                            </FormGroup>

                                            {/* Address */}
                                            <FormGroup>
                                                <Label htmlFor="name" required>Address</Label>
                                                <Input
                                                    id="address" name="address" type="text"
                                                    placeholder="Address..."
                                                    maxLength={100}
                                                    value={this.state.address}
                                                    onChange={(e) => this.updateState("address", e.target.value)}
                                                />
                                            </FormGroup>

                                            {/* Contact Person */}
                                            <FormGroup>
                                                <Label htmlFor="contactPerson" required>Contact Person<span className="text-danger"> *</span></Label>
                                                <Input
                                                    id="contactPerson" name="contactPerson" type="text"
                                                    placeholder="Contact Person..."
                                                    maxLength={100}
                                                    value={this.state.contactPerson}
                                                    onChange={(e) => this.updateState("contactPerson", e.target.value)}
                                                />
                                            </FormGroup>

                                            {/* Contact Phone Number */}
                                            <FormGroup>
                                                <Label htmlFor="contactPhoneNb" required>Contact Phone Number<span className="text-danger"> *</span></Label><br />
                                                <Input
                                                    className='product-mastersim-filter-dropdown-width'
                                                    id="contactPhoneNb" name="contactPhoneNb" type="text"
                                                    placeholder="Enter Phone Number"
                                                    maxLength={11}
                                                    value={this.state.contactPhoneNb}
                                                    onChange={(e) => this.updateState("contactPhoneNb", e.target.value)}
                                                />
                                            </FormGroup>

                                            {/* Sale Status */}
                                            <FormGroup>
                                                <Label htmlFor="name" required>Sale Status</Label>
                                                <Input
                                                    id="saleStatus" name="saleStatus" type="text"
                                                    placeholder="Sale Status..."
                                                    maxLength={100}
                                                    value={this.state.saleStatus}
                                                    onChange={(e) => this.updateState("saleStatus", e.target.value)}
                                                />
                                            </FormGroup>
                                            <Row lg="12" xs="12">
                                                <Col lg="6" xs="12">
                                                    <FormGroup>
                                                        <Label htmlFor="time">Topup Start Time</Label>
                                                        <Input
                                                            id="topupStartTime" value={this.state.startTime} name="topupStartTime" type="time"
                                                            placeholder="Please select topup start time"
                                                            onChange={(e) => { this.updateState("startTime", e.target.value) }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6" xs="12">
                                                    <FormGroup>
                                                        <Label htmlFor="time">Toup End Time</Label>
                                                        <Input
                                                            id="topupEndTime" value={this.state.endTime} name="topupEndTime" type="time"
                                                            placeholder="Please select topup end time"
                                                            onChange={(e) => { this.updateState("endTime", e.target.value) }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <FormGroup>
                                                <Label htmlFor="name" required>Notification Message</Label>
                                                <Input
                                                    id="notiMessage" name="notiMessage" type="textarea"
                                                    placeholder="Notification Message ..."
                                                    maxLength={3000}
                                                    value={this.state.notiMessage}
                                                    onChange={(e) => this.updateState("notiMessage", e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                                {this.state.errors.length > 0 &&
                                    <Alert color="danger" isOpen={this.state.messageVisible} toggle={() => this.setState({ messageVisible: false })}>
                                        {this.state.errors.map((msg, index) => (
                                            <span key={index}>{msg}<br /></span>
                                        ))}
                                    </Alert>
                                }
                                {this.state.successMessage !== "" &&
                                    <Alert color="success" isOpen={this.state.messageVisible} toggle={() => this.setState({ messageVisible: false })}>
                                        <span>{this.state.successMessage}<br /></span>
                                    </Alert>
                                }
                            </CardBody>


                            <CardFooter>
                                <Button type="submit" size="sm" color="primary" onClick={() => this.submitHandle()} ><i className="fa fa-dot-circle-o"></i> Update</Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button type="reset" size="sm" color="danger" onClick={() => this.cancelHandle()} ><i className="fa fa-ban"></i> Cancel</Button>
                            </CardFooter>

                            {/* <Modal isOpen={this.state.imageCropperModal} toggle={() => this.toggle("imageCropperModal")}>
                                <ModalFooter>
                                    <Button color="success" disabled={!this.state.imageCropperModal} onClick={() => this.setCroppedImage()}>Upload</Button>
                                    <Button color="secondary" onClick={() => this.toggle("imageCropperModal")}>Cancel</Button>
                                </ModalFooter>
                            </Modal> */}
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    validate() {
        let errors = [];

        if (this.state.companyName === null || this.state.companyName === "") {
            errors.push("* Company Name cannot be blank.");
        }
        if (this.state.phoneNb === null || this.state.phoneNb === "") {
            errors.push("* Phone Number cannot be blank.");
        }
        if (this.state.contactPerson === null || this.state.contactPerson === "") {
            errors.push("* Contact Person cannot be blank.");
        }
        if (this.state.contactPhoneNb === null || this.state.contactPhoneNb === "") {
            errors.push("* Contact Phone Number cannot be blank.");
        }
        if (errors.length > 0) {
            this.setState({
                errors, messageVisible: true,
                successMessage: '',
                isLoading: false,
            })
            return false;
        } else
            return true;
    }
    async submitHandle() {

        if (this.validate() === false) return;

        this.setState({ isLoading: true });

        let res = await saveCompanyInfo(this.state);
        if (res === 401) {
            this.setState({ isExpired: true })
        }
        else if (res.status) {
            this.setState({
                errors: [],
                successMessage: "Data has been saved successful.",
                messageVisible: true,
                isLoading: false,
                logoToDelete: "",
            });
            this.loadData();

        } else {
            this.setState({ errors: [res.message], messageVisible: true, successMessage: "", isLoading: false });
        }
    }
    cancelHandle() { 
        if(Object.keys(this.props.match.params).length === 1){
            this.props.history.push({pathname: CompanyEntryList.routeName});
        }else if(Object.keys(this.props.match.params).length === 0)
        this.props.history.push({ pathname: Dashboard.routeName }); 
    }

}
function mapStateToProps(state) {
    return { auth: state.auth };
}
export default connect(mapStateToProps)(CompanyInfoEntryDetail);